import type { Tone } from '../types/domain';
import type { ApplicationStatus, ComplaintStatus, ProfileStatus, RequestStatus } from '../types/owner';

export function appTone(s: ApplicationStatus): Tone {
  if (s === 'অনুমোদিত' || s === 'স্টিকার ইস্যুকৃত') return 'green';
  if (s === 'সংশোধন প্রয়োজন') return 'orange';
  if (s === 'বাতিল') return 'red';
  if (s === 'প্রক্রিয়াধীন') return 'blue';
  return 'orange';
}

export function ownerVehicleStatus(s: ApplicationStatus): { label: string; tone: Tone } {
  if (s === 'অনুমোদিত' || s === 'স্টিকার ইস্যুকৃত') return { label: 'যাচাইকৃত', tone: 'green' };
  if (s === 'সংশোধন প্রয়োজন') return { label: 'সংশোধন প্রয়োজন', tone: 'orange' };
  if (s === 'বাতিল') return { label: 'বাতিল', tone: 'red' };
  return { label: 'যাচাই অপেক্ষমাণ', tone: 'orange' };
}

export function stickerStatus(stage: number): { label: string; tone: Tone } {
  if (stage >= 7) return { label: 'ইস্যুকৃত', tone: 'green' };
  if (stage >= 6) return { label: 'সংগ্রহের জন্য প্রস্তুত', tone: 'blue' };
  if (stage >= 5) return { label: 'তৈরি হচ্ছে', tone: 'blue' };
  return { label: 'ইস্যু হয়নি', tone: 'gray' };
}

export function profileTone(s: ProfileStatus): Tone {
  if (s === 'যাচাইকৃত') return 'green';
  if (s === 'সংশোধন প্রয়োজন') return 'orange';
  if (s === 'বাতিল') return 'red';
  return 'orange';
}

export function requestTone(s: RequestStatus): Tone {
  if (s === 'অনুমোদিত') return 'green';
  if (s === 'বাতিল') return 'red';
  if (s === 'পর্যালোচনাধীন') return 'blue';
  return 'orange';
}

export function complaintTone(s: ComplaintStatus): Tone {
  if (s === 'সমাধানকৃত') return 'green';
  if (s === 'বন্ধ') return 'gray';
  if (s === 'পর্যালোচনাধীন') return 'blue';
  return 'orange';
}

export function stepState(stage: number, index: number, status: ApplicationStatus): { label: string; tone: Tone } {
  if (index < stage) return { label: 'সম্পন্ন', tone: 'green' };
  if (index === stage) {
    if (status === 'সংশোধন প্রয়োজন') return { label: 'সংশোধন প্রয়োজন', tone: 'orange' };
    if (status === 'বাতিল') return { label: 'বাতিল', tone: 'red' };
    return { label: 'প্রক্রিয়াধীন', tone: 'blue' };
  }
  return { label: 'অপেক্ষমাণ', tone: 'gray' };
}
